module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"section-margin\"> <h2>Payment Methods</h2> <div class=\"row\"> <div class=\"col-md-6 primary-method\"> <h5>Primary Method</h5> <div class=\"panel\"> <div id=\"primary_payment_method\"></div> </div> </div> <div class=\"col-md-6 secondary-method\"> <h5> Backup Method <small class=\"glyphicon glyphicon-question-sign text-muted\" data-toggle=\"tooltip\" title=\"We will use this to fund your account in case the primary payment method fails to charge or has an outstanding transfer.<br><br>Bank transfers take up to 5 business days to process</strong>, so it is recommended that bank account users register a backup card to ensure on-demand funding while transfers are processed.\" data-placement=\"bottom\"></small> </h5> <div class=\"panel\"> <div id=\"secondary_payment_method\"></div> </div> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/payment_method_details.ejs
// module id = 899
// module chunks = 1